export default "__VITE_ASSET__CYDwqkAr__"